// @flow

import { action, computed, observable } from "mobx";

import Model from "app/models/Model";
import TimelineItem from "app/models/TimelineItem";

export const themes = {
    DEFAULT: 0,
    LIGHT: 1,
    DARK: 2
};

export type VideoUseCaseDefinition = {
    title: string
};

export const useCases: { [_: string]: VideoUseCaseDefinition } = {
    business: {
        title: "Business"
    },
    education: {
        title: "Education"
    },
    entertainment: {
        title: "Entertainment"
    },
    social: {
        title: "YouTubers"
    }
};

export type VideoUseCaseMetadata = {
    title?: string,
    best_for?: string,
    hints?: string
};

export default class Video extends Model {
    rowid: number;
    uid: string;

    source: string;
    url: string;
    title: string;
    description: string;
    duration: number;
    thumbnail: string;
    source_thumbnail: string;
    timeline_thumbnail: ?string;

    private: boolean;
    homepage_visible: boolean;
    available: boolean;
    published_at: string;

    play_count: number;
    source_view_count: number;

    original_id: string;
    original_author_id: string;

    version: number;
    theme: number = 0;

    bgcolor: ?string;
    bgimage: ?string;

    author_name: ?string;
    author_username: ?string;
    author_image: ?string;
    author_slug: ?string;

    user_stoptime: ?number;

    created_by: ?string;
    created_by_guest: boolean;
    created_at: Date;
    updated_at: Date;
    deleted_at: ?Date;
    published_at: ?Date;

    @observable use_case: ?string;
    @observable use_case_metadata: ?VideoUseCaseMetadata;

    items: ?(TimelineItem[]);

    total_annotations: number = 0;

    normalize() {
        this.normalizeFloat("duration");
        this.normalizeInt(
            "play_count",
            "source_view_count",
            "version",
            "total_annotations"
        );
        this.normalizeBoolean(
            "private",
            "homepage_visible",
            "available",
            "created_by_guest"
        );
        this.normalizeDate(
            "created_at",
            "updated_at",
            "deleted_at",
            "published_at"
        );

        if (this.use_case_metadata) {
            // $FlowFixMe
            this.use_case_metadata = JSON.parse(this.use_case_metadata);
        }

        if (this.items) {
            this.items = TimelineItem.makeArray(this.items);
        }
    }

    getUseCaseMetadata(property: string) {
        return (this.use_case_metadata || {})[property] || "";
    }

    @action
    setUseCaseMetadata(property: string, value: any) {
        if (!this.use_case_metadata) this.use_case_metadata = {};
        this.use_case_metadata[property] = value;
    }

    @computed
    get isPublished(): boolean {
        return !!this.published_at;
    }

    @computed
    get isDeleted(): boolean {
        return !!this.deleted_at;
    }

    @computed
    get formattedCreatedAt(): string {
        const dateString = this.created_at.toDateString();
        const timeString = this.created_at.toTimeString().split(" ")[0];
        return dateString + " " + timeString;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Video.js